module.exports = __webpack_public_path__ + "static/media/kitchen3.d294d996.png";